import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components';

import { Link } from 'react-router-dom';
import { FaFacebookF, FaYoutube } from 'react-icons/fa6';



const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="box-container">
        
          {/* Event Information & Social Media Links */}
          <div className="footer-item">

            {/* Event Logo */}
            <Logo />

            {/* Event Description */}
            <p>賦能青年學習工程，擁抱競賽的激情，建立國際連結，讓你的機器人鋪就通往勝利的道路。</p>

            {/* Social Media Links */}
            <div className="social">
              <a href="https://www.facebook.com/worldrobotgames" target='_blank' rel="noreferrer"><FaFacebookF /></a>
              <a href="https://www.youtube.com/@WRG-RobotGames" target='_blank' rel="noreferrer"><FaYoutube /></a>
            </div>

            {/* Newsletter component to subscribe */}
            {/* <Newsletter variant='dark' idPrefix='2' /> */}

          </div>

          {/* Quick Links */}
          <div className="footer-item">
            <h2>Quick Links</h2>
            <div className="links">
              <p><Link to="/about">關於WRG</Link></p>
              <p><Link to="/tickets">報名</Link></p>
              <p><Link to="/schedule">比賽行程</Link></p>
              <p><Link to="/contact">與我們聯絡</Link></p>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Copyright */}
      <div className="content">
        <p>嵐奕科技有限公司設計與維護 | 版權所有 &Copyright 2025 -</p>
      </div>

    </footer>
  );
};

export default Footer;